module.exports = __webpack_public_path__ + "static/img/chejia_car_2.5a1e1d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Homepage/chejia_car_2.png
// module id = bPxA
// module chunks = 19